import axios from ".";

const _ = (url) => `/accounts/${url}`;

const auth = {
  register: (data) => axios.post(_("signup"), data),
  requestVerification: (data) => axios.post(_("signup/request-verification"), data),
  verifyOtp: (data) => axios.post(_("signup/verify-otp"), data),
  login: (data) => axios.post(_("login"), data),
  getProfile: () => axios.get(_("useruiprofile")),
  contact: (data) => axios.post(_("add-contact-message"), data),
  signupForNewsLetter: (data) => axios.post(_("newsletter-signup"), data),
  getWaterUsage: (meterOwnershipId) =>
    axios.get(_("usage"), { params: { meter_ownership_id: meterOwnershipId } }),
  checkNotifications: () => axios.get(_("has-notification")),
  setDailyLimit: (data) => axios.post(_("set-limit"), data),
  toggleDailyLimit: () => axios.post(_("toggle-daily-limit")),
  notifications: () => axios.get(_("notifications")),
  readNotifications: () => axios.get(_("mark-notifications-as-read")),
  getAppContent: () => axios.get(_("app-content")),
  fetchUsageStatistic: (usage_type) =>
    axios.get(_("usage-statistic"), { params: { usage_type } }),
  updateProfile: (data) => axios.patch(_("update-profile"), data),
  changePassword: (data) => axios.post(_("change-password"), data),
  resetPassword: (data) => axios.post(_("reset-password"), data),
  validateMeter: (data) => axios.post(_("validate-meter"), data),
  deleteDataRequest: (data) => axios.post(_("data-deletion-request"), data),
  editImage: (data) =>
    axios({
      url: _("change-image"),
      method: "PATCH",
      data,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    }),
  deRegisterMeter: (data) => axios.post(_("meters/detach"), data),
  registerMeter: (data) => axios.post(_("meters/attach"), data),
};

export default auth;
